export const OraMuiMenu = {
  styleOverrides: {
    paper: {
      backgroundColor: 'var(--surface-modal-glass-light)',
      color: 'var(--type-body-dark)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
    },
  },
};
